export default __webpack_public_path__ + "images/Q9.c5d68b0.png";